var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m390.628 345.372-45.256 45.256L256 301.255l-89.373 89.372-45.255-45.255L210.745 256l-89.372-89.373 45.254-45.254L256 210.745l89.372-89.373 45.256 45.255L301.255 256l89.373 89.372Z"}));
}

Close.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Close;

Close.default = Close;
